import BarChart from "./BarChart";
import React from "react";
import TimeChart from "./TimeChart";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  box-shadow: 0px 0px 10px #bababa;
  border-radius: 10px;

  .title {
    background-color: rgb(249, 248, 253);
    padding: 10px;
    border-radius: 10px;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: start;
  }

  .chartArea {
    display: flex;
    flex-direction: column;
    /* gap: 5px; */
    width: 100%;
    padding: 10px;
  }

  .chartAreaItem {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
  }
`;

const ActCard = ({ item, s_searchData }) => {
  return (
    <Wrapper>
      <div className="title">線別：{item.wlID}</div>
      <div className="chartArea">
        <div className="chartAreaItem">
          <span>日班(08:00 - 20:00)</span>
          <TimeChart
            type="morningData"
            date={s_searchData.date}
            data={item.morningData}
            width="100%"
          />
        </div>

        <div className="chartAreaItem">
          <span>夜班(20:00 - 08:00)</span>
          <TimeChart
            type="nightData"
            date={s_searchData.date}
            data={item.nightData}
            width="100%"
          />
        </div>
        <div className="chartAreaItem">
          <span>日班稼動率</span>
          <BarChart data={item.MorningACT} wrapWidth="100%" />
        </div>
        <div className="chartAreaItem">
          <span>夜班稼動率</span>
          <BarChart data={item.NightACT} wrapWidth="100%" />
        </div>
        <div className="chartAreaItem">
          <span>全天稼動率</span>
          <BarChart data={item.AllACT} wrapWidth="100%" />
        </div>
        {/* <BarChart data={item.MorningACT} /> */}
      </div>
    </Wrapper>
  );
};

export default ActCard;
